(() => {
  if (window.jeffCartAovReady) return;
  window.jeffCartAovReady = true;

  const getRoot = () => window.Shopify?.routes?.root || '/';

  const getModalState = (modal) => {
    if (!modal.jeffAovState) {
      const variantsElement = modal.querySelector('[data-jeff-aov-variants]');
      let variants = [];
      try {
        variants = JSON.parse(variantsElement?.textContent || '[]');
      } catch (error) {
        variants = [];
      }
      modal.jeffAovState = { variants, selected: {}, quantity: 1, trigger: null, modal, parent: null, nextSibling: null };
    }
    return modal.jeffAovState;
  };

  const getOptionGroups = (state) => [...state.modal.querySelectorAll('[data-jeff-aov-option-group]')];

  const findVariant = (state) => {
    const optionCount = getOptionGroups(state).length;
    return state.variants.find((variant) => {
      if (!variant.available) return false;
      const options = variant.options || [];
      for (let index = 0; index < optionCount; index += 1) {
        if (!state.selected[index] || options[index] !== state.selected[index]) return false;
      }
      return true;
    }) || null;
  };

  const updateModal = (modal) => {
    const state = getModalState(modal);
    const groups = getOptionGroups(state);
    groups.forEach((group, groupIndex) => {
      const buttons = [...group.querySelectorAll('[data-jeff-aov-option]')];
      const selected = state.selected[groupIndex] || '';
      const selectedLabel = group.querySelector('[data-jeff-aov-selected]');
      if (selectedLabel) selectedLabel.textContent = selected ? `: ${selected}` : '';
      buttons.forEach((button) => {
        const value = button.dataset.optionValue || '';
        const available = state.variants.some((variant) => {
          if (!variant.available || (variant.options || [])[groupIndex] !== value) return false;
          for (let index = 0; index < groups.length; index += 1) {
            if (index !== groupIndex && state.selected[index] && (variant.options || [])[index] !== state.selected[index]) return false;
          }
          return true;
        });
        button.disabled = !available;
        button.classList.toggle('is-selected', selected === value);
        button.setAttribute('aria-checked', selected === value ? 'true' : 'false');
      });
      if (selected && !buttons.some((button) => !button.disabled && button.dataset.optionValue === selected)) {
        delete state.selected[groupIndex];
      }
    });

    const variant = findVariant(state);
    const submit = modal.querySelector('[data-jeff-aov-submit]');
    if (submit) submit.disabled = !variant;
    const image = modal.querySelector('[data-jeff-aov-image]');
    if (image && variant?.featured_image?.src) image.src = variant.featured_image.src;
    return variant;
  };

  const openModal = (modal, trigger) => {
    const state = getModalState(modal);
    state.trigger = trigger;
    state.parent = modal.parentNode;
    state.nextSibling = modal.nextSibling;
    document.body.appendChild(modal);
    state.selected = {};
    state.quantity = 1;
    const quantityInput = modal.querySelector('[data-jeff-aov-quantity-input]');
    if (quantityInput) quantityInput.value = '1';
    const feedback = modal.querySelector('[data-jeff-aov-feedback]');
    if (feedback) feedback.textContent = '';
    updateModal(modal);
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    document.body.classList.add('jeff-aov-modal-open');
    modal.querySelector('.jeff-cart-aov-modal__close')?.focus({ preventScroll: true });
  };

  const closeModal = (modal) => {
    const state = getModalState(modal);
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.hidden = true;
    document.body.classList.remove('jeff-aov-modal-open');
    if (state.parent?.isConnected) {
      state.parent.insertBefore(modal, state.nextSibling);
    }
    state.trigger?.focus({ preventScroll: true });
    state.trigger = null;
  };

  const addToCart = async (modal, submit) => {
    const state = getModalState(modal);
    const variant = findVariant(state);
    if (!variant) return;
    const feedback = modal.querySelector('[data-jeff-aov-feedback]');
    submit.disabled = true;
    submit.setAttribute('aria-busy', 'true');
    if (feedback) feedback.textContent = '';
    try {
      const response = await fetch(`${getRoot()}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variant.id, quantity: state.quantity }],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || 'No se pudo añadir el producto.');
      closeModal(modal);
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && data.sections) {
        data.id = variant.id;
        drawer.renderContents(data);
      } else {
        window.location.reload();
      }
    } catch (error) {
      if (feedback) feedback.textContent = error.message;
      submit.disabled = false;
    } finally {
      submit.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const openTrigger = event.target.closest('[data-jeff-aov-open]');
    if (openTrigger) {
      const modal = document.querySelector(openTrigger.dataset.jeffAovModal);
      if (modal) openModal(modal, openTrigger);
      return;
    }
    const closeTrigger = event.target.closest('[data-jeff-aov-close]');
    if (closeTrigger) {
      const modal = closeTrigger.closest('.jeff-cart-aov-modal');
      if (modal) closeModal(modal);
      return;
    }
    const option = event.target.closest('[data-jeff-aov-option]');
    if (option) {
      const modal = option.closest('.jeff-cart-aov-modal');
      if (modal) {
        const state = getModalState(modal);
        state.selected[option.dataset.optionIndex] = option.dataset.optionValue;
        updateModal(modal);
      }
      return;
    }
    const quantityButton = event.target.closest('[data-jeff-aov-quantity]');
    if (quantityButton) {
      const modal = quantityButton.closest('.jeff-cart-aov-modal');
      const input = modal?.querySelector('[data-jeff-aov-quantity-input]');
      const state = modal && getModalState(modal);
      if (input && state) {
        const delta = quantityButton.dataset.jeffAovQuantity === 'increase' ? 1 : -1;
        state.quantity = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
        input.value = state.quantity;
      }
    }
  });

  document.addEventListener('input', (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.matches('[data-jeff-aov-quantity-input]')) return;
    const modal = event.target.closest('.jeff-cart-aov-modal');
    if (modal) getModalState(modal).quantity = Math.max(1, parseInt(event.target.value, 10) || 1);
  });

  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof Element)) return;
    const form = event.target.closest('[data-jeff-aov-form]');
    if (!form) return;
    event.preventDefault();
    const modal = form.closest('.jeff-cart-aov-modal');
    const submit = form.querySelector('[data-jeff-aov-submit]');
    if (modal && submit && !submit.disabled) addToCart(modal, submit);
  });

  document.addEventListener('keydown', (event) => {
    const modal = document.querySelector('.jeff-cart-aov-modal.is-open');
    if (!modal) return;
    if (event.key === 'Escape') {
      closeModal(modal);
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...modal.querySelectorAll('button:not(:disabled), input:not(:disabled), [href], [tabindex]:not([tabindex="-1"])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
